module.exports = __webpack_public_path__ + "static/media/facebook-square.938983a4.svg";